import { fetchData, buildAuthHeader } from '@eliadmin/core/src/api/fetcher';

type TUpdaterSubscription = {
  name: string | null;
  email: string | null;
  price_without_vat: number;
  hours: string;
  is_active: boolean;
  date_stop: string | null;
};

export const showSubscription = async ({
  locale,
  authToken,
}: {
  locale: string;
  authToken: string;
}) => {
  const response = await fetchData<{ data: TUpdaterSubscription[] }>({
    locale,
    method: 'GET',
    uri: 'store/updater/subscriptions/show',
    headers: buildAuthHeader(authToken),
    cache: 'no-store',
  });
  return response.data;
};

export const updateSubscription = async ({
  body,
  locale,
  authToken,
}: {
  body: { email: string };
  locale: string;
  authToken: string;
}) => {
  const response = await fetchData<{ data: TUpdaterSubscription[] }>({
    locale,
    method: 'PUT',
    uri: 'store/updater/subscriptions/update',
    body,
    headers: buildAuthHeader(authToken),
    cache: 'no-store',
  });
  return response.data;
};

export const activateSubscription = async ({
  locale,
  body,
  authToken,
}: {
  locale: string;
  body: { return_url: string };
  authToken: string;
}) => {
  const response = await fetchData<{ data: any }>({
    locale,
    method: 'POST',
    uri: 'store/updater/subscriptions/activate',
    headers: buildAuthHeader(authToken),
    body,
    cache: 'no-store',
  }).catch(error => {
    throw error;
  });
  return response.data;
};

export const cancelSubscription = async ({
  locale,
  authToken,
}: {
  locale: string;
  authToken: string;
}) => {
  const response = await fetchData<{ data: TUpdaterSubscription[] }>({
    locale,
    method: 'POST',
    uri: 'store/updater/subscriptions/cancel',
    headers: buildAuthHeader(authToken),
    cache: 'no-store',
  });
  return response.data;
};
